export const statuses = {
  free: {
    label: 'Свободно',
    variant: 'primary',
  },
  blocked: {
    label: 'Блокировано',
    variant: 'danger',
  },
  booked: {
    label: 'Забронировано',
    variant: 'warning',
  },
  sold: {
    label: 'Продано',
    variant: 'success',
  },
  created: {
    label: 'Создано',
    variant: 'primary',
  },
  printed: {
    label: 'Напечатан',
    variant: 'secondary',
  },
  selling: {
    label: 'Реализация',
    variant: 'warning',
  },
  payed: {
    label: 'Оплачено',
    variant: 'success',
  },
  issued: {
    label: 'Выдано',
    variant: 'secondary',
  },
  returned: {
    label: 'Возвращено',
    variant: 'danger',
  },
  revoked: {
    label: 'Аннулировано',
    variant: 'danger',
  },
}

export const timezonesList = [
  {
    id: 2,
    label: 'Калининград (GMT+2)',
  },
  {
    id: 3,
    label: 'Москва (GMT+3)',
  },
  {
    id: 4,
    label: 'Самара (GMT+4)',
  },
  {
    id: 5,
    label: 'Екатеринбург (GMT+5)',
  },
  {
    id: 6,
    label: 'Омск (GMT+6)',
  },
  {
    id: 7,
    label: 'Новосибирск (GMT+7)',
  },
  {
    id: 8,
    label: 'Иркутск (GMT+8)',
  },
  {
    id: 9,
    label: 'Якутск (GMT+9)',
  },
  {
    id: 10,
    label: 'Владивосток (GMT+10)',
  },
  {
    id: 11,
    label: 'Сахалин (GMT+11)',
  },
  {
    id: 12,
    label: 'Петропавловск-Камчатский (GMT+12)',
  },
]
